angular.module('bmsApp.directives')
	.controller('ProximityInfoModalCtrl', [
		'$scope',
		'$q',
		'$timeout',
		'$modalInstance',
		'ProximitySvc',
		'EmployeeOptionsSvc',
		'license',
		'postcode',
		'durationInMinutes',
		function (
			$scope,
			$q,
			$timeout,
			$modalInstance,
			ProximitySvc,
			EmployeeOptionsSvc,
			license,
			postcode,
			durationInMinutes) {

			$scope.loading = true;
			$scope.processing = false;


			$scope.mileOptions = [
				{
					id: 2,
					label: '2 miles',
				},
				{
					id: 5,
					label: '5 miles',
				},
				{
					id: 10,
					label: '10 miles',
				},
				{
					id: 15,
					label: '15 miles',
				},
				{
					id: 20,
					label: '20 miles',
				},
				{
					id: 40,
					label: '40 miles',
				},
				{
					id: 50,
					label: '50 miles',
				},
			];

			$scope.employee;
			$scope.days = {// preset weekdays
				monday: false,
				tuesday: false,
				wednesday: false,
				thursday: false,
				friday: false,
				saturday: false,
				sunday: false
			}

			$scope.params = {
				license_id: license.id,
				postcode: postcode,
				max_distance_miles: 5,
				days: 14,
			}
			if(durationInMinutes){
				$scope.params.job_duration_mins = durationInMinutes;
			}

			loadProximityInfo();

			function loadProximityInfo() {
				$scope.loading = true;
				ProximitySvc.nearByRoutes($scope.params)
					.then(function (response) {
						$scope.dates = response.data.dates;
						formatTimeValues();
						processData();
						loadEmployeeDetails();
					}, function (error) {
						$scope.errors = error;
					})
					.finally(function () {
						$scope.loading = false;
					});
			}

			function processData() {
				$scope.dates.forEach(function (date){
					var dateTotalTimeSlots = null;
					var dateClosestMiles = null;
					date.routes.forEach(function(route){
						if(route.available_time_slots && route.available_time_slots.start_times.length > 0){
							dateTotalTimeSlots += route.available_time_slots.start_times.length;
						}
						if(route.closest_distance_miles && (dateClosestMiles == null || route.closest_distance_miles < dateClosestMiles)){
							dateClosestMiles = route.closest_distance_miles;
						}
					});
					date.totalTimeSlots = dateTotalTimeSlots;
					date.closestMiles = dateClosestMiles;
				});
			}

			function loadEmployeeDetails() {
				$scope.loading = true;
				EmployeeOptionsSvc.employee({filter: {status: true}})
					.then(function (response) {
						$scope.employeeOptions = response.data.options;
					}, function (error) {
						$scope.errors = error;
					})
					.finally(function () {
						$scope.loading = false;
					});
			}

			$scope.formvalidatorconfig = {
				submitHandler: function () {
					loadProximityInfo();
				},
				errorPlacement: function (error) {
					error.appendTo('#errors');
				},
				errorContainer: '#errors'
			};

			$scope.cancel = function () {
				$modalInstance.dismiss('cancel');
			};

			function formatTimeValues(){
				$scope.dates.forEach(function (date){
					date.routes.forEach(function(route){
						route.visits.forEach(function(visit){
							if(visit.arrival_time){
								visit.arrival_time = new Date(date.date + ' ' + visit.arrival_time);
							}
						})
					});
				});
			}

			$scope.selectedEmployee = function(employee){
				$scope.employee = employee;
			}

			$scope.isDaySelected = function(day){
				day = day.toLowerCase();
				if($scope.days.monday == true && 'monday' == day){
					return true;
				}
				else if($scope.days.tuesday == true && 'tuesday' == day){
					return true;
				}
				else if($scope.days.wednesday == true &&  'wednesday' == day){
					return true;
				}
				else if($scope.days.thursday == true && 'thursday' == day){
					return true;
				}
				else if($scope.days.friday == true && 'friday' == day){
					return true;
				}
				else if($scope.days.saturday == true && 'saturday' == day){
					return true;
				}
				else if($scope.days.sunday == true && 'sunday' == day){
					return true;
				}
				return false;
			}

			$scope.isNoDaySelected = function() {
				if(!$scope.days.monday && !$scope.days.tuesday && !$scope.days.wednesday && !$scope.days.thursday
					&& !$scope.days.friday && !$scope.days.saturday && !$scope.days.sunday) {
					return true;
				}
			}

			$scope.selectedTimeSlot = function(time_slot, employee){
				$modalInstance.close({
					dateTime: moment(time_slot),
					employee: employee
				});
			}

			$scope.hasSelectedEmployee = function(date){
				if(!$scope.employee){
					return true;
				}
				var employeeAvailable = false;
				angular.forEach(date.routes, function(route){
					if(route.employee.id == $scope.employee.id){
						employeeAvailable = true;
					}
				});
				return employeeAvailable;
			}
		}
	]);
